import request from '@/utils/infrastructure/communication/request';

export async function generateReportToken(id) {
  return request(`/report/generateToken/${id}`, {
    method: 'POST',
  });
}

export async function updateFavorite({ id, isFavorite }) {
  return isFavorite
    ? request.delete(`/report/favorites/${id}`, {})
    : request.post(`/report/favorites/${id}`, {});
}
